import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../../../interfaces';

@Pipe({
  name: 'columnNames',
  standalone: true,
})
export class ColumnNamesPipe implements PipeTransform {
  transform(columns: Column[]): unknown {
    return columns.map((column) => column?.name);
  }
}
